<template>
	<div class="app-wrapper" :class="{hideSidebar:!sidebar.opened, noSideBar: !hasMenu}">
		<sidebar class="sidebar-container" v-if="hasMenu"></sidebar>
		<div class="main-container">
			<!--<navbar></navbar>-->
			<tags-view v-if="hasTitle"></tags-view>
			<app-main></app-main>
		</div>
	</div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components'
export default {
  name: 'layout',
  created() {
    if (this.$route.query && this.$route.query.hasMenu) {
      if (this.$route.query.hasMenu === 'false') {
        this.hasMenu = false
      }
    }
    if (this.$route.query && this.$route.query.hasTitle) {
      if (this.$route.query.hasTitle === 'false') {
        this.hasTitle = false
      }
    }
  },
  data() {
    return {
      hasMenu: true,
      hasTitle: true
    }
  },
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import "src/styles/mixin.scss";
	.app-wrapper {
	  @include clearfix;
	  position: relative;
	  height: 100%;
	  width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue